<script lang="ts">
  import { Button, Form, FormGroup, Input, InputGroup, InputGroupText, Label } from 'sveltestrap';
  import { useNavigate } from 'svelte-navigator';
  import { userName } from '../store';
  import {  EmailAddress, Login, Password, Signinwith, Welcomeback } from '../utils/Constant/Constant';
  import LoginSocial from './LoginSocial.svelte';
  const navigate = useNavigate();
  var email:string = 'test@gmail.com';
  var password:string = 'test123';
  var togglePassword:boolean = false;
  var loading:boolean = false;
  const loginAuth = (e) => {
    e.preventDefault();
    if (email === 'test@gmail.com' && password === 'test123') {
      loading = true;
      localStorage.setItem('Name', 'ename');
      userName.set('ename');
      navigate('/dashboard/default', { replace: true });
      window.location.reload()
    }
  };
</script>
<Form class="theme-form login-form">
    <h4>{Login}</h4>
    <h6>{Welcomeback}</h6>
    <FormGroup>
        <Label>{EmailAddress}</Label>
        <InputGroup>
            <InputGroupText>
                <i class="icon-email"></i>
            </InputGroupText>
            <Input type="email" required placeholder="Test@gmail.com" on:change={(e) => (email = e.target.value)} value={email} />
        </InputGroup>
    </FormGroup>
    <FormGroup>
      <Label>{Password}</Label>
      <InputGroup>
        <InputGroupText>
            <i class="icon-lock"></i>
        </InputGroupText>
        <Input type={togglePassword ? 'text' : 'password'} on:change={(e) => (password = e.target.value)} value={password} required >
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div class="show-hide" on:click={() => (togglePassword = !togglePassword)}>
                <span class:show={togglePassword === true}></span>
            </div>
        </Input>
      </InputGroup>
    </FormGroup>
    <FormGroup>
        <Button color="primary" disabled={loading ? loading : loading} on:click={(e) => loginAuth(e)}>{loading ? 'LOADING...' : 'Sign In'}</Button>
    </FormGroup>
    <div class="login-social-title">                
        <h5>{Signinwith}</h5>
    </div>
    <LoginSocial />
</Form>